import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=65dec3e6&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=65dec3e6&scoped=true&lang=scss&"
import style1 from "./comment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dec3e6",
  null
  
)

export default component.exports